// extracted by mini-css-extract-plugin
export default {"wrapper":"ShipClass_wrapper_c726f"};